import { createSlice } from '@reduxjs/toolkit';
import { authApi } from '../api/authApi';

const initialUserState = {
  user: {},
  account: {},
  userList: { list: [], cursor_id: '' },
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    clearUser: () => initialUserState,
    updateUser: (state, { payload }) => {
      console.log('payload', payload);
      state.user = payload;
    },
    updateAccount: (state, { payload }) => {
      state.account = payload;
    },
    updateUserList: (state, { payload }) => {
      state.userList = payload;
    },
    clearUserList: (state) => {
      state.userList = { list: [], cursor_id: '' };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.authenticateUser.matchFulfilled, (state, { payload }) => {
      console.log('payload', payload);
      state.user = payload.result.user;
      state.account = payload.result.account;
    });
  },
});

export const { clearUser, updateUser, updateAccount, clearUserList, updateUserList } =
  userSlice.actions;
export default userSlice.reducer;
